import React, { useState } from "react";
import PropTypes from "prop-types";

import PersonPreview from "components/PersonPreview";
import { userTypes } from "domain/GamesSearch/types";
import Icon from "components/Icon";
import { noop } from "lodash-es";

const AddPlayerInterfaceUserItem = ({
    player,
    addOnItemClick,
    renderAdditional,
    trainers,
    ...props
}) => {
    const { id, family_name, name, avatar, is_participate } = player;
    const [disabled, setDisabled] = useState(false);
    const isTrainerInSchool = trainers?.find(
        (user) => Number(user?.id) === Number(player?.id)
    );

    const addPlayer = async () => {
        setDisabled(true);
        try {
            await props.addPlayer(player);
        } finally {
            setDisabled(false);
        }
    };

    return (
        <div className="players-list__item">
            <PersonPreview
                id={id}
                key={`player-list-item-${id}`}
                family_name={family_name}
                name={name}
                avatar={avatar}
                mods={[`person--row`]}
                onClick={addOnItemClick ? addPlayer : noop}
            />

            {typeof renderAdditional === "function" &&
                renderAdditional({ player, id })}

            {!addOnItemClick && (
                <div className="players-list__right">
                    {is_participate || isTrainerInSchool ? (
                        <>
                            {props.successText ? (
                                <p className="btn btn--small fs-button c-gs-disabled ml-auto">
                                    {props.successText}
                                </p>
                            ) : (
                                <Icon type="done" />
                            )}
                        </>
                    ) : (
                        <button
                            type="button"
                            className="btn btn--small btn--text"
                            onClick={addPlayer}
                            disabled={disabled}
                        >
                            <span>{props.selectButtonText}</span>
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

AddPlayerInterfaceUserItem.defaultProps = {
    selectButtonText: "Добавить",
    renderAdditional: noop(),
};

AddPlayerInterfaceUserItem.propTypes = {
    player: userTypes,
    addPlayer: PropTypes.func.isRequired,
    selectButtonText: PropTypes.string,
    successText: PropTypes.string,
    hideControl: PropTypes.bool,
    addOnItemClick: PropTypes.bool,
    renderAdditional: PropTypes.func,
    trainers: PropTypes.array,
};

export default AddPlayerInterfaceUserItem;
